import {
    APP_CONFIG
} from '@/utils/constants'
import HttpService from "@/utils/httpData"

const getHomeSlide = params => {
    let apiEndpoint = `book/get-homepage-slide`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => {
        return false
    });
}

export const apiGetListNotication = (values) => {
    let apiEndpoint = `Notification/GetList`;
    return HttpService.post(apiEndpoint, values).then(res => {
        return res.data ? res.data : null;
    }).catch(e => {
        return false
    })
}

export const apiNotificationListNotificationType = () => {
    let apiEndpoint = 'notification/ListNotiType';
    return HttpService.post(apiEndpoint)
        .then(res => {
            return res;
        })
}
export const apiDeleteNotication = (values) => {
    let apiEndpoint = `Notification/DeleteNotification`
    return HttpService.post(apiEndpoint, values)
        .then(res => {
            return res;
        })
}
export default {
    getHomeSlide
}